// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"ModalWindow_modal_wrapper__F2Dnc","modal_title":"ModalWindow_modal_title__af0Gr","modal_text":"ModalWindow_modal_text__liiAd"};